import getApiBaseUrl from "./getApiBaseUrl";

export const fetchPageData = async (
  endpoint,
  method,
  errorMessage,
  token,
  payload
) => {
  const options = {
    method: method,
    headers: {
      // "Content-Type": "application/json",
      // Authorization: "Bearer " + token,
    },
  };
  token && (options.headers["Authorization"] = "Bearer " + token);
  if (method !== "GET") {
    options.body = payload;
  }

  try {
    const response = await fetch(
      `${getApiBaseUrl("http")}/${endpoint}`,
      options
    );
    let isError = false;
    // if (response.status === 422) {
    //   throw new Error("Validation failed.");
    // }
    // if (response.status === 401) {

    //   localStorage.removeItem("token");
    // }

    if (response.status !== 200 && response.status !== 201) {
      isError = true;
    }
    const data = await response.json();

    return { data: data, error: isError, status:response.status };
  } catch (err) {
    return { data: null, error: err };
  }
};
